import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import CompanyData from '../../companyData';
import { styled } from '@material-ui/core';
import commons from '../../../../../assets/styles/commons';
import Users from '../usersTable';
import FreightConfiguration from '../../freightConfiguration';
import PrivateDriversTable from '../../privateDrivers/privateDriversTable';
import FormCreateDistributorUser from '../createUser';
import FormUpdateDistributorUser from '../editUser';
import { useLocation } from 'react-router-dom';

const TabListCustom = styled(TabList)(() => ({
  '& .MuiTabs-flexContainer': {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

const TabCustom = styled(Tab)(() => ({
  '&.MuiTab-root': {
    flex: 1,
    textTransform: 'none',
    fontFamily: commons.fontFamily,
    fontWeight: 700,
    color: '#2E3A59',
  },
}));

const UserTabs: React.FC = () => {
  const location = useLocation<{ tab: string }>();

  const [selectedUserId, setSelectedUserId] = React.useState('');
  const [value, setValue] = React.useState(location?.state?.tab || '1');

  const handleChange = (event: React.ChangeEvent<any>, newValue: string) => {
    setValue(newValue);
  };

  const renderUserTabContent = () => {
    const [content, setContent] = React.useState('');
    const handleChangeContent = (newContentValue: string) => {
      setContent(newContentValue);
    };
    if (content === 'newUser') {
      return <FormCreateDistributorUser onClick={handleChangeContent} />;
    }

    if (content === 'editUser') {
      return (
        <FormUpdateDistributorUser
          onClick={handleChangeContent}
          selectedUserId={selectedUserId}
        />
      );
    }

    return (
      <Users onClick={handleChangeContent} onUserSelect={setSelectedUserId} />
    );
  };

  return (
    <Box sx={{ width: '100%' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabListCustom onChange={handleChange} indicatorColor="primary">
            <TabCustom label="Dados da empresa" value="1" />
            <TabCustom label="Administradores" value="2" />
            <TabCustom label="Configuração de fretes" value="3" />
          </TabListCustom>
        </Box>
        <TabPanel value="1" style={{ padding: 0, marginTop: 20, flex: 1 }}>
          <CompanyData />
        </TabPanel>
        <TabPanel value="2" style={{ padding: 0, marginTop: 20, flex: 1 }}>
          {renderUserTabContent()}
        </TabPanel>
        <TabPanel value="3" style={{ padding: 0, marginTop: 20, flex: 1 }}>
          <FreightConfiguration />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default UserTabs;
